<template>
  <div class='h-dialogContainer'>
    <form :id="formId">
      <div class='h-subscriber-inputLit'>{{$t('MCS.participantType')}}:</div>
      <ejs-dropdownlist :fields='fields' :dataSource='optionsUserType' :value='userTypeValue' v-model='typeVal'/>
      <div class='h-subscriber-inputLit' style="margin-top: 18px">{{$t('MCS.userNum')}}:</div>
      <!--<ejs-textbox  cssClass='h-subscriber-inputBoxDiv' :value='userNumValue' v-model='numVal' name='userNum'></ejs-textbox>-->
      <ejs-textbox :value='numVal' v-model='numVal' name="userNum" maxlength='15' @keydown.native.enter='keydown'></ejs-textbox>
<!--
      <input :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model='numVal' name='userNum'/>
-->
    </form>
  </div>
</template>

<script>
import commonJS from '../../common';
import { FormValidator } from '@syncfusion/ej2-vue-inputs';

export default {
  name: 'SearchDialog',
  mixins: [commonJS],
  props: [
    'userTypeValue',
    'userNumValue',
    'reFreshGrid'
  ],
  data() {
    return {
      validateObj: undefined,
      typeVal: this.userTypeValue === undefined ? 0 : this.userTypeValue,
      numVal: this.userNumValue === undefined ? '' : this.userNumValue,
      formValidateObj: '',
      formId: 'searcgFormId',
    };
  },
  methods: {
    keydown(){
      event.stopPropagation();//禁用回车事件
      event.preventDefault();
    },
    checkValid() {
      const checkStatus = this.validateObj.validate();
      return checkStatus;
    },
    bindValidate() {
      const validationOption = {
        customPlacement(inputElement, errorElement) {
          errorElement.style.position = 'fixed';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          userNum: {
            regex: ["^\\d+$", this.$t('SubscriberIms.invalideChar')],
            rangeLength: [[1, 15], this.$t('SubscriberIms.maxlen15')],
          }
        },
      };
      this.validateObj = new FormValidator(`#${this.formId}`, validationOption);
    },
    search() {
      this.reFreshGrid(this.typeVal, this.numVal);
    },
    setData(type, num) {
      this.typeVal = type,
      this.numVal = num;
    }
  },
};
</script>

<style scoped>

</style>
